export enum SEARCH_TYPE {
  SEARCH = "search",
  HISTORY = "history",
  TRENDING_QUERY = "trending_queries", /*          */
  SUGGEST = "suggest",
  MODIFIED = "modified"
}
